import { Link } from 'react-router-dom';
import { trendingArticles } from '@/mocks/news';

export default function TrendingSidebar() {
  return (
    <div className="lg:w-[320px] flex-shrink-0">
      <div className="bg-background-50 rounded-lg border border-background-200 p-5 sticky top-20">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-fire-line text-accent-500 text-lg"></i>
          </div>
          <h3 className="font-heading text-lg font-semibold text-foreground-950">
            热门排行
          </h3>
        </div>
        <div className="flex flex-col gap-1">
          {trendingArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex items-start gap-3 p-2.5 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold ${
                  index < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h4>
                <p className="text-xs text-secondary-500 mt-1">
                  {article.views.toLocaleString()} 阅读
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-5 pt-4 border-t border-background-100">
          <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-3">
            热门标签
          </h4>
          <div className="flex flex-wrap gap-2">
            {['明星', '爆料', '网红', '娱乐圈', '直播', '八卦', '综艺', '品牌'].map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium cursor-pointer hover:bg-secondary-200 transition-colors"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}